import React from 'react';
import ItemTypes, { defaultConfigComponent as ItemTypesConfig } from '../ItemTypes/ItemTypes';
import { IConfigComponent } from '@ts/ui-models';

interface LocationTypesProps {}

export const defaultConfigComponent = (): IConfigComponent => {
  return {
    ...ItemTypesConfig,
    componentId: 'locationsType',
    where: { typeParams: { mainFlavor: 'location' } },
  };
};

const LocationTypes: React.FC<LocationTypesProps> = props => {
  return <ItemTypes {...props} configComponent={defaultConfigComponent()} />;
};
export default LocationTypes;
